<template>
  <div id="app">
    <div class="main-title" v-if="$route.path != '/introduce' && $route.path != '/jump2senlin'">
      {{ $store.state.title ? $store.state.title : $route.meta.title }}
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isReload">

    </router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isReload: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url(~@/assets/css/iconfont.css);

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  -webkit-overflow-scrolling: touch;
}

.main-title {
  height: 88px;
  line-height: 88px;
  font-size: 34px;
  text-align: center;
}
</style>
